import React from 'react';
import './Skills.css';

const Skills = ({ skills, skillModifiers, updateCharacter }) => {



  return (
    <div className="skills-list">
      <h3>Skills</h3>
      {Object.keys(skills).map((skill) => (
        <div key={skill} className={`skill-row ${skills[skill] ? 'proficient' : ''}`}>
          <div className="skill-checkbox">
            <input
              type="checkbox"
              checked={skills[skill]}
              readOnly
              title="Manage skills via Class/Race/Feat selections in the Traits tab"
            />
          </div>
          <div className="skill-label">{skill.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())}</div>
          <div className="skill-mod">
            {skillModifiers[skill] >= 0 ? '+' : ''}{skillModifiers[skill]}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Skills;
